module.exports = __webpack_public_path__ + "static/media/barometric-pressure.dcfd9ebf.svg";